import { Backdrop, CircularProgress } from '@mui/material'

export function Dimming({ on }: { on: boolean }): React.ReactElement {
  return <Backdrop
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={on}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
}
